// Hooks
import useSocialProfiles from '@/utils/hooks/swr/useSocialProfiles';
import useTranslation from '@/utils/hooks/translation/useTranslation';

import useStateWithReset from '@/utils/hooks/utils/useStateWithReset';

// Components
import H3 from '@/components/base/Headings/H3';
import Icon from '@/components/base/Icon';
import InfoBanner from '@/components/base/InfoBanner/CompoundBanner';
import Loader from '@/components/base/Loader';
import SocialProfilesConnectedList from '@/components/pages/signup/connectSocialProfiles/SocialProfilesAdded/SocialProfilesConnectedList';
import SocialProfilesDataReassurance from '@/components/pages/signup/connectSocialProfiles/SocialProfilesAdded/SocialProfilesDataReassurance';
import SocialProfilesErrorFetchingData from '@/components/pages/signup/connectSocialProfiles/SocialProfilesAdded/SocialProfilesFetchingDataError';

const SocialProfilesAdded = () => {
    const { t } = useTranslation('signup_funnel');
    const [
        errorDeletingSocialProfile,
        setErrorDeletingSocialProfile,
        resetErrorDeletingSocialProfile
    ] = useStateWithReset<string>(null);
    const { socialProfiles, socialProfilesError, isLoading } = useSocialProfiles();

    if (isLoading) {
        return (
            <div className="mt-8 flex flex-1 items-center justify-center p-8 xl:mt-24">
                <Loader className="h-7 w-7 text-icoBlue" />
            </div>
        );
    }

    if (!socialProfiles?.length) {
        return <SocialProfilesDataReassurance />;
    }

    return (
        <div
            data-testid="social-profiles-wrapper"
            className="relative flex h-full flex-col space-y-8">
            {errorDeletingSocialProfile ? (
                <InfoBanner className="mb-4">
                    <InfoBanner.Icon />
                    <InfoBanner.Content message={errorDeletingSocialProfile} />
                    <InfoBanner.Close onClose={resetErrorDeletingSocialProfile} />
                </InfoBanner>
            ) : null}
            <div className="flex flex-row items-center justify-between px-3">
                <H3 className="font-GSemiBold">
                    {t('connect_social_profiles.social_profiles_connected')}
                </H3>
                <span className="flex flex-row items-center space-x-1.5 rounded-full border border-icoBlue-200 bg-white px-2 py-1.5 text-icoBlue">
                    <Icon icon="single-profile" className="text-sm" />
                    <span className="text-xs">{socialProfiles.length}</span>
                </span>
            </div>

            {socialProfilesError ? (
                <SocialProfilesErrorFetchingData />
            ) : (
                <>
                    <div className="absolute bottom-0 left-0 z-20 hidden w-full pr-4 lg:block">
                        <div className="h-20 w-full bg-icoGray100GradientBottomToTop"></div>
                    </div>
                    <div className="scrollbar flex-1 pr-4 lg:pb-20">
                        <SocialProfilesConnectedList
                            onDeleteError={() => {
                                setErrorDeletingSocialProfile(
                                    t('connect_social_profiles.error_delete_social_profile')
                                );
                            }}
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default SocialProfilesAdded;
